import {Link} from 'react-router-dom';
import React from 'react';

import {HeadlineH1} from '../arkulpa-fec/components/Text';
import {NewButton} from '../arkulpa-fec/components/FormElements';
import EntityTable from '../arkulpa-fec/components/EntityTable';
import LoadingIndicator from '../arkulpa-fec/components/LoadingIndicator';

const _tableConfig = () => {
  return {
    maxRows: 30,
    cols: [
      {
        header: 'Titel',
        valueKey: 'title',
        method: title => title,
        width: '50%',
      },
      {
        header: 'Url',
        valueKey: 'slug',
        method: slug => slug,
        width: '30%',
      },
      {
        header: 'Typ',
        valueKey: 'type',
        method: type => type,
        width: '20%',
      },
    ],
  };
};

export default ({data: {searchContents, loading}, history}) => (
  <div>
    <HeadlineH1>Content</HeadlineH1>
    <NewButton>
      <Link to="/new/content">New Content</Link>
    </NewButton>
    <EntityTable
      tableConfig={_tableConfig()}
      data={searchContents}
      msg={'No Content found'}
      onRowClicked={row => history.push('/content/' + row._id)}
    />
    {loading && <LoadingIndicator />}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Contents.js